<nav id="parmed-navbar" class="navbar navbar-default menu-bar">
    <div id="par-navbar-collapse" class="collapse menubar-items-display"  [ngClass]="{'paddingMajor':websiteName=='Major'}">
        <ul class="nav navbar-nav menu-icons no-mobile menu-links">
            <!-- <li *ngIf="!isAuthenticated && websiteName=='Major'" [routerLinkActive]="['active-menu-item']">
                <a id="nav-home" class="li-lower" (click)="routeClick(routes.home)">Home
                   
                </a>
            </li> -->
             <li *ngIf="!isAuthenticated && websiteName=='Parmed'" [routerLinkActive]="['active-menu-item']">
                <a id="nav-home" (click)="routeClick(routes.home)">Home
                    <!-- <img src="/assets/images/home.png" width="25" height="25"> -->
                </a>
            </li>
        </ul>
        <ul class="nav navbar-nav menu-links no-mobile menulinks-padding">
             <li *ngIf="websiteName=='Major'" [routerLinkActive]="['active-menu-item']">
                <a id="nav-home" class="li-lower" (click)="routeClick(routes.home)">Home
                    <!-- <img src="/assets/images/home.png" width="25" height="25"> -->
                </a>
            </li>
            <li *ngIf="!isAuthenticated && websiteName == 'Parmed'" [routerLinkActive]="['active-menu-item']">
                <a id="nav-about-us" (click)="routeClick(routes.aboutus)">About Us</a>
            </li>
            <li *ngIf="websiteName == 'Major'" [routerLinkActive]="['active-menu-item']">
                <a id="nav-about-us" class="li-lower" (click)="routeClick(routes.majorAboutUs)">About</a>
            </li>
            <li *ngIf="!isAuthenticated && websiteName == 'Parmed'" [routerLinkActive]="['active-menu-item']">
                <a id="nav-products-services" (click)="routeClick(routes.productServices)">Products and Services</a>
            </li>
            <li *ngIf="websiteName == 'Major' && isUnauthSearchEnabled" [routerLinkActive]="['active-menu-item']">
                <a  id="nav-product-catalog-list" class="li-lower" (click)="routeClick(routes.productCatalogList)"  >Products</a>
            </li>
            <li *ngIf="websiteName == 'Major'" [routerLinkActive]="['active-menu-item']">
                <a id="nav-package-insert" class="li-lower" (click)="routeClick(routes.majorAmazon)">Amazon</a>
            </li>
            <li *ngIf="websiteName == 'Major'" [routerLinkActive]="['active-menu-item']">
                <a id="nav-package-insert" class="li-lower" (click)="routeClick(routes.majorNews)">News</a>
            </li>
            <li *ngIf="!isAuthenticated && websiteName=='Parmed'" [routerLinkActive]="['active-menu-item']">
                <a id="nav-contact-us" (click)="routeClick(routes.contactUs)">Contact us</a>
            </li>
            <li *ngIf="websiteName=='Major'" [routerLinkActive]="['active-menu-item']">
                <a id="nav-contact-us" class="li-lower" (click)="routeClick(routes.contactUs)">Contact Us</a>
            </li> 
            <!-- <li *ngIf="!isAuthenticated && websiteName == 'Major' && isUnauthSearchEnabled" [routerLinkActive]="['active-menu-item']">
                <a  id="nav-product-catalog-list" (click)="routeClick(routes.productCatalogList)"  >Product Catalog</a>
            </li> -->
            <li *ngIf="websiteName == 'Major'" [routerLinkActive]="['active-menu-item']">
                <a id="nav-package-insert" class="li-lower" (click)="routeClick(routes.packageInsert)">Package Inserts</a>
            </li>
        </ul>
        <ul class="nav navbar-nav navbar-right search-bar menu-links margin-right-0" *ngIf="websiteName=='Parmed'">

            <!-- <li *ngIf="isAuthenticated && websiteName == 'Major'" >
                <a id="nav-priceChange" style="text-transform: none;" (click)="openDialog()" ><u>Price changes since last login</u></a>
            </li> -->
            
            <li *ngIf='isAuthenticated' [routerLinkActive]="['active-menu-item']">
                <a id="nav-myhome" (click)="routeClick(routes.myhome)">Home</a>
            </li>
            <li *ngIf='isAuthenticated' [routerLinkActive]="['active-menu-item']" (click)="getPromotion(); getCategories();">
                <a id="nav-shop" [matMenuTriggerFor]="shopmenu">Shop <span class="caret white-caret"></span></a>
            </li>
            <mat-menu #shopmenu="matMenu">
                <button id="nav-categories" *ngIf="websiteName == 'Major'" mat-menu-item 
                (click)="shopMenu.closeMenu()" [matMenuTriggerFor]="categoryMenu" (click)="routeClick(routes.categories)">Categories</button>
                <button id="nav-categories" *ngIf="websiteName == 'Parmed' && isParmedCategoriesFlag" mat-menu-item 
                (click)="shopMenu.closeMenu()" [matMenuTriggerFor]="parmedCategoryMenu" (click)="routeClick(routes.categories)">Categories</button>
                <button id="nav-promotions-menu" *ngIf="hasPromotions" mat-menu-item (click)="shopMenu.closeMenu()"
                    [matMenuTriggerFor]="promotionMenu"  (click)="routeClick(routes.promotions)">Promotions</button>
                <button id="nav-promotions" *ngIf="!hasPromotions" mat-menu-item (click)="shopMenu.closeMenu()"
                (click)="routeClick(routes.promotions)">Promotions</button>
                <button id="nav-favorites" mat-menu-item (click)="routeClick(routes.favorites)">Favorites</button>
                <button id="nav-watchList" mat-menu-item (click)="routeClick(routes.watchList)">Watchlist</button>
                <button id="nav-recent-launch-generics" *ngIf='websiteName=="Parmed"' mat-menu-item
                    (click)="onRecentlyLaunchedGenericsClick()">Recently Launched Generics</button>
                <button id="nav-recent-order" mat-menu-item (click)="routeClick(routes.producthistory)">Recently
                    Ordered</button>
                <button id="nav-dispill" *ngIf='websiteName=="Parmed"' mat-menu-item
                     (click)="routeClick(routes.dispill)">Dispill</button>
                <button id="nav-quick-order" mat-menu-item (click)="routeClick(routes.quickOrder)">Quick Order</button>
                <button id="nav-product-catalog" *ngIf='websiteName=="Parmed"' mat-menu-item
                    (click)="routeClick(routes.fullCatalog)">Product Catalog</button>
            </mat-menu>
            <mat-menu #promotionMenu="matMenu">
                <button mat-menu-item *ngFor="let promotion of promotions; let i = index" id="promotion-{{i+1}}"
                    (click)="onPromotionClick(promotion);routeClick(this.routes.promotionDetails + promotion.categoryId);">{{promotion.name}}</button>
            </mat-menu>
            <mat-menu #categoryMenu="matMenu">
                <button mat-menu-item *ngFor="let category of categories; let i = index" id="category-{{i+1}}"
                    (click)="routeClick(this.routes.categoryDetails + category.itemListID)">{{category.displayLabel}}</button>
            </mat-menu>
            <mat-menu #parmedCategoryMenu="matMenu">
                <button mat-menu-item *ngFor="let category of categories; let i = index" id="category-{{i+1}}"
                    (click)="routeClick(this.routes.categoryDetails + category.categoryId)">{{category.name}}</button>
            </mat-menu>
            <li *ngIf='isAuthenticated' [routerLinkActive]="['active-menu-item']">
                <a id="nav-my-account" [matMenuTriggerFor]="myaccountmenu">My Account <span
                        class="caret white-caret"></span></a>
            </li>
            <mat-menu #myaccountmenu="matMenu">
                <button id="nav-pay-invoice" *ngIf='websiteName=="Major"' mat-menu-item
                    (click)="routeClick(routes.payInvoices)">Pay My Invoices</button>
                <button id="nav-payment-portal" *ngIf='websiteName=="Parmed"' mat-menu-item
                    (click)="onBillerDirectClick()">Online Payment Portal</button>
                <button id="nav-order-history" mat-menu-item (click)="routeClick(routes.orderHistory)">Order History</button>
          
                <button id="nav-search-dscsa" mat-menu-item (click)="routeClick(routes.searchTransactionData)" *ngIf = "!ifDatePresent">Search
                    DSCSA</button>

                <button id="nav-search-dscsa" mat-menu-item [matMenuTriggerFor]="searchDSCSA" *ngIf = "ifDatePresent">Search
                    DSCSA</button>
                    <mat-menu #searchDSCSA="matMenu">
                        <button mat-menu-item (click)="routeClick(routes.searchTransactionData)"  *ngIf = "ifDatePresent && websiteName == 'Parmed'" >Thru {{previousDString}}</button>
                        <button id="nav-dscsa-reporting" mat-menu-item (click)="routeClick(routes.dscsaReporting)"   *ngIf = "ifDatePresent && websiteName == 'Parmed'">From {{lookerReportEffectiveDate}}</button>
                        <button mat-menu-item (click)="routeClick(routes.searchTransactionData)"  *ngIf = "ifDatePresent && websiteName == 'Major'">Lot-based</button>
                        <button id="nav-dscsa-reporting" mat-menu-item (click)="routeClick(routes.dscsaReporting)"   *ngIf = "ifDatePresent && websiteName == 'Major'">Serialized</button>
                     
                    </mat-menu>
                  
                <button id="nav-manage-cards" mat-menu-item (click)="routeClick(routes.creditCards)">Manage Credit
                    Cards</button>
                <button *ngIf="isSubscriptionEnabled" id="nav-my-subscriptions" mat-menu-item (click)="routeClick(routes.subscription)">Subscriptions</button>
                <button id="nav-csos-orders" *ngIf='websiteName=="Parmed"  && enableCsosItems' mat-menu-item
                     (click)="routeClick(routes.csosOrderHistory)">Submitted CSOS Orders</button>
                <button id="nav-register-csos" *ngIf='websiteName=="Parmed" && enableCsosItems' mat-menu-item
                    (click)="onCsosSignCertificateClick()">Register CSOS Signing Certificate</button>
                <button id="nav-request-return" *ngIf='websiteName=="Parmed"' mat-menu-item
                    (click)="routeClick(routes.productReturn)">Request a Return</button>
                <button id="nav-customer-forms" *ngIf='websiteName=="Parmed"' mat-menu-item
                     (click)="routeClick(routes.customerForms)">Customer Forms</button>
            </mat-menu>
            <li *ngIf="isAuthenticated && expertMedFlg && websiteName == 'Parmed'">
                <a id="nav-expertMed" class="expertMedNav" (click)="onExpertMedClick()">ExpertMed</a>
            </li>
             <li *ngIf="isAuthenticated && websiteName == 'Major'" [routerLinkActive]="['active-menu-item']">
                <a id="nav-about-us"  (click)="routeClick(routes.majorAboutUs)">About</a>
            </li>
             <li *ngIf="isAuthenticated && websiteName == 'Major'" [routerLinkActive]="['active-menu-item']">
                <a id="nav-package-insert" (click)="routeClick(routes.majorAmazon)">Amazon</a>
            </li>
             <li *ngIf="isAuthenticated && websiteName == 'Major'" [routerLinkActive]="['active-menu-item']">
                <a id="nav-package-insert" (click)="routeClick(routes.majorNews)">News</a>
            </li>
            <li *ngIf='isAuthenticated' [routerLinkActive]="['active-menu-item']">
                <a id="nav-contact-us" (click)="routeClick(routes.contactUs)">Contact Us</a>
            </li>
            <li *ngIf="isAuthenticated && websiteName == 'Major'" [routerLinkActive]="['active-menu-item']">
                <a id="nav-package-insert" (click)="routeClick(routes.packageInsert)">Package inserts</a>
            </li>
            <!-- <li *ngIf="isAuthenticated && websiteName == 'Major'"  [routerLinkActive]="['active-menu-item']">
                <a  id="nav-product-catalog-list" (click)="downloadFile()" >Product Catalog</a>              
              </l
              i> -->
                 <li *ngIf="isAuthenticated && websiteName == 'Major'" [routerLinkActive]="['active-menu-item']">
                <a  id="nav-product-catalog-list"  (click)="routeClick(routes.productCatalogList)"  >Products</a>
            </li>
            <li id="chat-unavailable" [routerLinkActive]="['active-menu-item']" class="cursor-pointer"
                *ngIf="(!chatAvailable || !chatEnable) && websiteName=='Parmed'" title="Chat Unavailable">
                <div class="navbar-chaticon">
                    <div>
                        <img src="/assets/images/icon_chat-gray.png" width="35" height="35">
                    </div>
                    <div class="navbar-chattext">
                        <div>CHAT<br>LATER</div>
                    </div>
                </div>
            </li>
            <li id="chat-available" [routerLinkActive]="['active-menu-item']" class="cursor-pointer"
                *ngIf="chatAvailable && chatEnable && websiteName=='Parmed'" title="Chat Available"
                (click)="onInitiateChatClick()">
                <div class="navbar-chaticon">
                    <div>
                        <img src="/assets/images/icon_chat-green.png" width="35" height="35">
                    </div>
                    <div class="navbar-chattext">
                        <div>CHAT<br>NOW</div>
                    </div>
                </div>
            </li>
        </ul>
      
        <form (submit)="onSearchProductSubmit()" *ngIf="isAuthenticated">
            <div class="nav navbar-nav search-bar" *ngIf="websiteName=='Parmed'">
                <div class="navbar-form navbar-left search-fields" id="searchForm">
                    <div class="form-group search-form">
                        <input id="nav-search-text" type="search" [formControl]="searchProduct"
                            placeholder="Search products" maxlength= "100" (ngModelChange)="onSearchChange()"
                            [matAutocomplete]="auto" />
                            
                        <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete">
                            <mat-option *ngFor="let option of productSuggestions" [value]="option">
                                {{option | uppercase}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                </div>
                 <img src="/assets/images/search-magnifying-glass-icon.png" id="nav-search"  class="search-icon"
                    (click)="onSearchProductSubmit()" />
                <!-- <div class="search-buttons">
                <input id="nav-search" type="submit" name="search-btn" value="" />
                
        </div> -->
               
               
            </div>
              <!-- <div class="nav navbar-nav search-bar" *ngIf="websiteName=='Major'">
                <div class="navbar-form navbar-left search-fields" id="searchForm">
                    <div class="form-group search-form">
                        <input id="nav-search-major" type="search" [formControl]="searchProduct"
                            placeholder="Search products" maxlength= "100" (ngModelChange)="onSearchChange()"
                            [matAutocomplete]="auto" />
                             <img src="/assets/images/search-magnifying-glass-icon.png" id="nav-search" style="margin: 10px -30px;"   class="search-icon-major"
                    (click)="onSearchProductSubmit()" />
                        <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete">
                            <mat-option *ngFor="let option of productSuggestions" [value]="option">
                                {{option | uppercase}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                </div>
                
               
               
            </div> -->
        </form>
    </div>
</nav>